document.addEventListener('DOMContentLoaded', function(){
  var reviews = {
    "bandes-de-resistance": [
      {a:"Marie L.",d:"02/04/2026",r:5,t:"Parfait pour mes séances à la maison. Les 5 niveaux permettent de progresser vraiment. Qualité au top."},
      {a:"Thomas R.",d:"28/03/2026",r:5,t:"J’hésitais avec Amazon mais là c’est un autre niveau. Les bandes sont solides."},
      {a:"Sophie M.",d:"15/03/2026",r:4,t:"Très bon rapport qualité-prix. La plus forte résistance est vraiment intense. Livré en 2 jours."}
    ],
    "foam-roller": [
      {a:"Julie K.",d:"05/04/2026",r:5,t:"Après chaque course, c’est devenu indispensable. La haute densité masse vraiment en profondeur."},
      {a:"Marc D.",d:"01/04/2026",r:5,t:"Kiné recommandé. Bien meilleur que les rollers bas de gamme. La texture grip est parfaite."},
      {a:"Camille B.",d:"22/03/2026",r:4,t:"Fait le job pour la récup. Un peu intense au début mais on s’y fait. Livraison rapide."}
    ],
    "kettlebell": [
      {a:"Nicolas P.",d:"08/04/2026",r:5,t:"Génial, une seule kettlebell qui remplace 7 poids. Le système de verrouillage est solide."},
      {a:"Laura F.",d:"30/03/2026",r:5,t:"Compacte et bien finie. Le changement de poids est rapide. Parfait pour mon petit appart."},
      {a:"David H.",d:"18/03/2026",r:4,t:"Très pratique. Seul bémol : un peu bruyante quand on change les poids. Sinon top qualité."}
    ],
    "fitness-bar": [
      {a:"Amélie S.",d:"06/04/2026",r:5,t:"Kit complet et bien pensé. Les bandes s’accrochent facilement à la barre."},
      {a:"Rémi G.",d:"25/03/2026",r:5,t:"Remplacé mon abonnement salle par ça. Honnêtement pour le prix c’est imbattable."},
      {a:"Chloé V.",d:"12/03/2026",r:4,t:"Bonne qualité, la barre est solide. Les bandes auraient pu être un poil plus longues."}
    ],
    "barre-de-traction": [
      {a:"Florian M.",d:"09/04/2026",r:5,t:"Installation en 20 secondes, aucun trou dans le mur. Tient parfaitement à 85kg."},
      {a:"Sarah T.",d:"03/04/2026",r:5,t:"Mon copain était sceptique mais elle tient super bien. On l’utilise tous les deux."},
      {a:"Julien A.",d:"20/03/2026",r:4,t:"Solide et pratique. Le système de contre-pression fonctionne bien."}
    ],
    "tapis-yoga": [
      {a:"Manon C.",d:"07/04/2026",r:5,t:"Enfin un tapis qui ne glisse pas. Le jute donne un super grip même en transpiration."},
      {a:"Paul E.",d:"29/03/2026",r:5,t:"Écologique et efficace. L’odeur naturelle du jute est agréable. Bonne épaisseur."},
      {a:"Inès W.",d:"14/03/2026",r:4,t:"Très beau tapis, antidérapant comme promis. Un peu lourd mais pour la maison c’est parfait."}
    ]
  };
  var handle = window.location.pathname.split('/').pop();
  var matched = null;
  for (var k in reviews) {
    if (handle.indexOf(k) !== -1) { matched = reviews[k]; break; }
  }
  if (!matched) return;
  var container = document.getElementById('ls-reviews-list');
  if (!container) return;
  var html = '';
  matched.forEach(function(rv) {
    var stars = '';
    for (var i = 0; i < rv.r; i++) stars += '★';
    html += '<div class="ls-review-card"><div class="ls-review-header"><span class="ls-review-author">' + rv.a + '<span class="ls-review-badge">Achat vérifié</span></span><span class="ls-review-date">' + rv.d + '</span></div><div class="ls-review-rating">' + stars + '</div><div class="ls-review-text">' + rv.t + '</div></div>';
  });
  container.innerHTML = html;
});